<template>
    <router-view ></router-view>
</template>

<style scoped>





</style>

<script>


    
	export default {
        name: 'Home',
        props: ['user'],
        ceated(){
            Vue.vuetify.preset.rtl = false;
        },
        async beforeMount() {





		}
    }
</script>
